import { axiosGeolocation } from "../api.js";

class LocationServiceFacade {
  

    /**
     * Cria variável no localstorage com coordenadas do usuário
     */
    setGeoLocation(callbackSuccess, callbackError){
        let result;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(callbackSuccess, callbackError,
        {timeout: 10000, enableHighAccuracy: false});
      }
      return result;
    }
  
    /**
     * Retorna a latitude e longitude do usuário em um array a partir da API de Geolocalização HTML
     */
    getPosition(){
      return JSON.parse(localStorage.getItem('location'));
    }
    
    /**
     * Retorna uma array com os códigos de países da língua portuguesa
     */
    getPtCountriesCode() {
      return ['AO','BR','CV','GQ','GW','MO','MZ','PT','ST','TL'];
    }
    
    /**
     * Retorna uma array com os códigos de países da língua espanhola
     */
    getEsCountriesCode() {
      return ['AR','BO','CL','CO','CU','CR','DO','EC','ES','GQ','GT','HN','MX','NI','PA','PE','PY','SV','UY','VE'];
    }
  
    /**
     * Retorna o código do idioma do usuário
     */
    getCountryID(callback, errorCallback) {
        axiosGeolocation.post().then(callback).catch(errorCallback);
    }
  
    

    /**
     * Retorna o idioma com base no código do país
     */
    getLang(callback) {
      this.getCountryID((response) => {
        var countryCode = response.data.countryCode;
        if(this.getPtCountriesCode().includes(countryCode)) {
            
          callback('br');
        } else if(this.getEsCountriesCode().includes(countryCode)) {
            
          callback('es');
        } else {
            
          callback('en');
        }
      }, (e) => { console.log('Não foi possível identificar o país de origem',e)})
    }
  
    /**
     * Verifica se a flag para bloquear o warning de mudança de idioma existe
     */
    getChangeLang() {
      return (JSON.parse(localStorage.getItem('changeLang')) === null) ? false : true;
    }
  
    /**
     * Bloqueia o warning de mudança de
     */
    setChangeLang() {
      localStorage.setItem('changeLang', JSON.stringify(1));
    }
  
}

export default LocationServiceFacade;